import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useSelector } from 'react-redux';

import { SuiContainer } from '@splashthat/sui';
import FormTemplateLibraryCollection from './FormTemplateLibraryCollection';
import { getCategoryFilteredTemplates, getIsAdditional } from '../../selectors/templateLibrary';
import { PROTECTED_FIELD_CATEGORY } from '../../constants/templateLibrary';

const baseClassName = 'FormTemplateLibraryCategory';

const DisabledParagraph = styled.p`
    margin-bottom: 0.75rem;
`;

export const DISABLED_PARAGRAPH_LABEL = 'Protected fields cannot be added to a Question Group.';

const FormTemplateLibraryCategory = ({ category, onClickTemplate }) => {
    const inputTypeTemplates = useSelector(getCategoryFilteredTemplates([category]));
    const isAdditional = useSelector(getIsAdditional);
    const disableProtectedQuestions = category === PROTECTED_FIELD_CATEGORY && isAdditional;

    return (
        <SuiContainer className={baseClassName} variation="flex-vertical flex-inherit">
            {disableProtectedQuestions && <DisabledParagraph>{DISABLED_PARAGRAPH_LABEL}</DisabledParagraph>}
            <FormTemplateLibraryCollection
                templates={inputTypeTemplates}
                onClickTemplate={onClickTemplate}
                qaId={baseClassName}
                disabledItems={disableProtectedQuestions}
            />
        </SuiContainer>
    );
};

FormTemplateLibraryCategory.propTypes = {
    category: PropTypes.string.isRequired,
    onClickTemplate: PropTypes.func.isRequired,
};

export default FormTemplateLibraryCategory;
